import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetGeneratedMarketplaceCampaignDetail.graphql';
import { Query, QuerygetGeneratedMarketplaceCampaignDetailArgs } from '../../__generated__/globalTypes';

export const useGetGeneratedMarketplaceCampaignDetailQuery = (
  options?: QueryHookOptions<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetGeneratedMarketplaceCampaignDetailLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>
): QueryResult<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs> & {
  getGetGeneratedMarketplaceCampaignDetail: LazyQueryExecFunction<
    Query,
    QuerygetGeneratedMarketplaceCampaignDetailArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetGeneratedMarketplaceCampaignDetail, result] = useLazyQuery<
    Query,
    QuerygetGeneratedMarketplaceCampaignDetailArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetGeneratedMarketplaceCampaignDetail, ...result };
};

export const useGetGeneratedMarketplaceCampaignDetailPromiseQuery = () => {
  const client = useApolloClient();

  const getGetGeneratedMarketplaceCampaignDetail = useCallback(
    (options?: Omit<QueryOptions<QuerygetGeneratedMarketplaceCampaignDetailArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetGeneratedMarketplaceCampaignDetail };
};
// Suspense Query Hooks
export const useGetGeneratedMarketplaceCampaignDetailSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetGeneratedMarketplaceCampaignDetailArgs>(QUERY, {
    ...options
  });

  return result;
};
